import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

export interface MetaStatusItem {
  title: string
  description: string
  link: string
  pubDate: string
  guid: string
}

export interface MetaStatus {
  status: 'operational' | 'outage' | 'unknown'
  items: MetaStatusItem[]
  lastBuild?: string
  checkedAt?: string
  error?: string
}

// Status da Graph API (feed oficial de incidentes da Meta). Refaz a cada 5min,
// alinhado ao cache do backend. Não estoura toast em erro (silencioso).
export function useMetaStatus() {
  return useQuery<MetaStatus>({
    queryKey: ['meta-status', 'graph-api'],
    queryFn: () => api.get<MetaStatus>('/meta-status/graph-api'),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
